import React from "react";
import { StyledAppointmentsSessionCalendar } from "../../../../../styled/appointments";

const AppointmentSessionCalendar = ({ onClick, appointment }) => {
  return (
    <StyledAppointmentsSessionCalendar.Container>
      <StyledAppointmentsSessionCalendar.TitleContainer>
        <StyledAppointmentsSessionCalendar.Title variant="body2">
          AGREGAR TURNO
        </StyledAppointmentsSessionCalendar.Title>
      </StyledAppointmentsSessionCalendar.TitleContainer>
      <StyledAppointmentsSessionCalendar.Calendar
        tileClassName={{
          height: 30,
          padding: 0,
        }}
        view="month"
        onClickDay={onClick}
        minDate={appointment.fechaHora}
      />
    </StyledAppointmentsSessionCalendar.Container>
  );
};

export default AppointmentSessionCalendar;
